import {enableProdMode, LOCALE_ID} from '@angular/core';
import {platformBrowserDynamic} from '@angular/platform-browser-dynamic';

import {AppModule} from './app/app.module';
import {environment} from './environments/environment';


if (environment.production) {
  enableProdMode();
}

platformBrowserDynamic([{provide: LOCALE_ID, useValue: 'it'}])
  .bootstrapModule(AppModule, {providers: [
    {provide: LOCALE_ID, useValue: 'it'}
  ]})
  .catch(err => console.log(err));
